import * as React from 'react';
import { appStore } from 'kts-platform-frame/api';
import { IAppInfo } from 'kts-platform-frame/dataModel';
import { history } from 'kts-platform-frame/routes';
import { AppType, AppSystemType } from 'kts-platform-frame/entry/constant';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import { appIndexUri } from 'kts-platform-frame/entry/configUtils';
import JSString from 'kts-scaffold-framework/utils/kit/JSString';
import UIAppContainer from './UI.AppContainer';
import { message } from 'antd';

/** 开启APP */
export default async function openApp(target: any, app: string | IOptions, state: any) {
    // new Promise<Response<IAppInfo>>
    if (typeof app === 'string') {
        app = new Options(app);
    }

    const queryAppInfo = await appStore.queryAppInfo(target, { appKey: app.appKey, isMessage: app.isMessage === false ? false : true });
    if (queryAppInfo.er) {
        return queryAppInfo;
    }

    switch (app.openType) {
        case OPEN_TYPE.右侧弹窗:
            openRightPopWindow(app, queryAppInfo.res);
            return queryAppInfo;

        case OPEN_TYPE.右侧框架:
            openRightSideFrame(app, queryAppInfo.res, state);
            return queryAppInfo;

        case OPEN_TYPE.嵌入APP:
            return await embedApp(app, queryAppInfo.res);

        default:
            console.error('参数错误');
            break;
    }
}

/** 打开位置 */
export enum OPEN_TYPE {
    右侧弹窗 = 0,
    右侧框架 = 1,
    嵌入APP = 2,
}

/** 参数项目接口 */
export interface IOptions {

    /** appKey */
    appKey: string;

    /** 打开方式 */
    openType: OPEN_TYPE;

    /** 打开时路由 */
    routing?: string;

    /** 开启参数 */
    parameter?: any;

    //打开宽度
    width?: number;

    /** 是否显示提示现象 */
    isMessage?: boolean;

    /** 是否使用 replace 不计入历史 */
    replace?: boolean;
}

/** 参数项目 */
class Options implements IOptions {

    /** appKey */
    public appKey: string;

    /** 打开方式 */
    public openType: OPEN_TYPE = OPEN_TYPE.右侧框架;

    /** 打开时路由 */
    public routing: string = '';

    public parameter: any;

    constructor(appKey: string) {
        this.appKey = appKey;
    }
}

/** 实现 右侧弹窗打卡 */
function openRightPopWindow(app: IOptions, appInfo: IAppInfo) {

    if (AppType.system === appInfo.appType) {
        const config = MyStore.instance.getState().config.appList.map.get(app.appKey);
        if (config.TYPE === AppSystemType.核心功能) {
            message.error("不支持的打开方式");
            return;
        }
    }

    MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.add, {
        title: appInfo.appName,
        Components: <UIAppContainer appInfo={appInfo} options={app} />,
        width: app.width
    });
}

/** 实现 右侧框架打开 */
function openRightSideFrame(app: IOptions, appInfo: IAppInfo, state: any) {

    const fn = app.replace ? history.replace : history.push;

    if (AppType.system === appInfo.appType) {

        const config = MyStore.instance.getState().config.appList.map.get(app.appKey);
        if (config && config.TYPE === AppSystemType.核心功能) {
            const appUrl = appIndexUri(app.appKey);
            if (!appUrl) {
                console.error('APP配置错误', config);
                return;
            }

            if (app.routing) {
                fn(`${appUrl}/${app.routing}?${JSString.stringify(app.parameter)}`, state);
            } else {
                fn(`${appUrl}?${JSString.stringify(app.parameter)}`, state);
            }

            return;
        }
    }

    const routing = doRouting(app.routing, app.parameter);
    fn(`/workbench/m/${appInfo.appKey}/?routing=${encodeURIComponent(routing)}`, state || { appInfo });
}

/** 实现 嵌入APP */
async function embedApp(app: IOptions, appInfo: IAppInfo) {
    const routing = doRouting(app.routing, app.parameter);
    if (AppType.system === appInfo.appType) {
        const config = MyStore.instance.getState().config.appList.map.get(app.appKey);
        if (config.TYPE === AppSystemType.核心功能) {
            message.error('不支持的打开方式');
            return { err: '不支持的打开方式', app, appInfo };
        }

        const appUrl = appIndexUri(app.appKey);

        if (!appUrl) {
            console.error('APP配置错误', config);
            return { err: 'APP配置错误', app, appInfo };
        }

        return { appIndex: `${appUrl}/${routing}`, app, appInfo };
    }

    return { appIndex: `${appInfo.appIndexUri}/${routing}`, app, appInfo };
}

function doRouting(routing: string = '', parameter: any): string {
    if (routing.indexOf('/') === 0) {
        routing = routing.substr(1);
    }
    return parameter ? `${routing || ''}?${JSString.stringify(parameter)}` : `${routing || ''}`;
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/appSdk/openApp/index.tsx